var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguageDarkTickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selection_box_1",
    "data-name": "Selection box 1",
    transform: "translate(-0.748 -0.514)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Selection_box",
    "data-name": "Selection box",
    width: 20,
    height: 20,
    rx: 10,
    transform: "translate(0.748 0.514)",
    fill: "#a49dc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_268",
    "data-name": "Subtraction 268",
    d: "M8858.285,8964.279a.749.749,0,0,1-.533-.221l-2.83-2.83a.753.753,0,1,1,1.064-1.066l2.3,2.3,5.126-5.128a.754.754,0,1,1,1.065,1.066l-5.658,5.662A.759.759,0,0,1,8858.285,8964.279Z",
    transform: "translate(-8848.951 -8950.597)",
    fill: "#1e1b31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageDarkTickIcon);
export default __webpack_public_path__ + "static/media/language-darkTick-icon.88a3a8f7a3f6c15690ebf67472ae1413.svg";
export { ForwardRef as ReactComponent };